import type { FunctionType } from "models-webgl2";

export const isFunction = (value: any): value is FunctionType => {
  return value && {}.toString.call(value) === "[object Function]";
};
